import { render, staticRenderFns } from "./NoteListTagsList.vue?vue&type=template&id=4559446e&scoped=true&"
import script from "./NoteListTagsList.vue?vue&type=script&lang=js&"
export * from "./NoteListTagsList.vue?vue&type=script&lang=js&"
import style0 from "./NoteListTagsList.vue?vue&type=style&index=0&id=4559446e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4559446e",
  null
  
)

export default component.exports